import React from "react";
import "./Style.css";
import logo from "assests/logo.png";
const LoadingScreen = () => {
  return (
    <div className="scroll-section w-full h-[100vh] bg-black text-white fixed z-[1000] flex flex-col items-center justify-center ">
      <div className="flex mb-24 items-center">
        <img className="w-44" src={logo} alt="" />
      </div>
      <div className="loader">
        <div className="loader--dot"></div>
        <div className="loader--dot"></div>
        <div className="loader--dot"></div>
        <div className="loader--dot"></div>
        <div className="loader--dot"></div>
        <div className="loader--dot"></div>
      </div>
      <div className="loader--text mt-10">
        <p>Loading...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
// import React from "react";
// import "./Style.css";
// import logo from "assests/logo.png";
// const LoadingScreen = () => {
//   return (
//     <div className="scroll-section w-full h-[100vh] bg-black text-white relative z-[1000] flex flex-col items-center justify-center">
//       <div className="flex mb-24 items-center">
//         <img className="w-44" src={logo} alt="" />
//       </div>
//       <div className="loader">
//         <div class="loader--dot"></div>
//         <div class="loader--dot"></div>
//         <div class="loader--dot"></div>
//         <div class="loader--dot"></div>
//         <div class="loader--dot"></div>
//         <div class="loader--dot"></div>
//       </div>
//       <div class="loader--text mt-10">
//         <p>Loading...</p>
//       </div>
//     </div>
//   );
// };

// export default LoadingScreen;
